import { render, staticRenderFns } from "./MassifRecord.vue?vue&type=template&id=c43c0024&scoped=true"
import script from "./MassifRecord.vue?vue&type=script&lang=js"
export * from "./MassifRecord.vue?vue&type=script&lang=js"
import style0 from "./MassifRecord.vue?vue&type=style&index=0&id=c43c0024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43c0024",
  null
  
)

export default component.exports